import { constrainPoint, flexibleCompare } from '@fullcalendar/core/internal';
import { FullscreenExit } from '@mui/icons-material';
import { Box, MenuItem, Select, TextField, InputLabel, FormControl, Typography, Button, TextareaAutosize } from '@mui/material';
import { createMetaTemplate } from 'api/services/communication';
import { snack } from 'components/toast';
import React, { useRef, useState } from 'react';
import { useMutation } from 'react-query';

const WhatsAppTemplateCreator = () => {
  const [templateName, setTemplateName] = useState('');
  const [language, setLanguage] = useState('');
  const [variable, setVariable] = useState('');
  const [header, setHeader] = useState('');
  const [body, setBody] = useState('');
  const [dynamicVariables, setDynamicVariables] = useState<string[]>([]);
  const [footerText, setFooterText] = useState('');
  const [category,setCategory] = useState('');
  const [quickReplyText, setQuickReplyText] = useState('');
  const [headerHandle, setHeaderHandle] = useState<string[]>([]);
  const [headerText, setHeaderText] = useState('');
  const languages = ['en', 'en_US'];
  const variables = ['Number','Name']
  const headers = ['None','Text','Image','Document']
  const categories = ['MARKETING','UTILITY']

  const { mutate:create, isLoading: isSending } = useMutation(createMetaTemplate, {
    onSuccess: () => {
        snack.success('Created Template Sucessfully, please wait until it is reviewed')

    },
    onError: (err: any) => {
        console.log('Error sending message:', err);
    },
});
  const handleBodyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setBody(value);

    const matchedVars = Array.from(new Set(value.match(/{{\d+}}/g) || []));
    setDynamicVariables(matchedVars);
  };

  const buildRequestBody = () => {
    const components: any[] = [];
  
    // Add HEADER if applicable
    if (header !== 'None') {
      const headerComponent: any = {
        type: 'HEADER',
        format: header.toUpperCase(), // 'TEXT', 'IMAGE', 'DOCUMENT'
      };
  
      if (header === 'Text') {
        headerComponent.text = headerText;
        headerComponent.example = {
          header_text: [headerText || 'Sample Header']
        };
        
      }
      else if (header === 'Image' || header === 'Document') {
        headerComponent.example = {
          header_handle: [headerHandle[0]],
        };
      }
  
      components.push(headerComponent);
    }
  
    // BODY (required)
    const bodyComponent: any = {
      type: 'BODY',
      text: body,
    };
  
    // Collect body sample values from inputs — for now, mock values
    if (dynamicVariables.length > 0) {
      bodyComponent.example = {
        body_text: [
          dynamicVariables.map((_, idx) => `Sample ${idx + 1}`)
        ]
      };
    }
  
    components.push(bodyComponent);
  
    // FOOTER (optional)
    if (footerText) {
      components.push({
        type: 'FOOTER',
        text: footerText,
      });
    }
  
    // BUTTONS — currently skipped but you can add later
    // BUTTONS (optional)
const buttonsComponent: any = {
  type: 'BUTTONS',
  buttons: [],
};

if (quickReplyText) {
  buttonsComponent.buttons.push({
    type: 'QUICK_REPLY',
    text: quickReplyText,
  });
}


if (buttonsComponent.buttons.length > 0) {
  components.push(buttonsComponent);
}

  
    const requestBody = {
      name: templateName.toLowerCase().replace(/ /g, '_'), // use underscore as required
      language: language,
      category: category,
      components: components
    };
  
    return requestBody;
  };
  
  const submitTemplate = async () => {
    const requestBody = buildRequestBody();
    create(requestBody); // uses React Query's mutate

  };
  

  const bodyRef = useRef<HTMLInputElement | null>(null);

  const handleTemplateChange = (e) => {
    setTemplateName(e.target.value);
  };
  const handleFooterChange = (e) => {
    setFooterText(e.target.value);
  };

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };
  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };
  const handleVariableChange = (e) => {
    setVariable(e.target.value);
  };

  const handleHeaderChange = (e) => {
    setHeader(e.target.value);
    // setUploadedFile(null);
    setHeaderText('');
  };

  const handleHeaderTextChange = (e) => {
    // setHeader(e.target.value);
    // setUploadedFile(null);
    setHeaderText(e.target.value);
  };

  const insertVariableAtCursor = () => {
    if (!bodyRef.current) return;

    const textarea = bodyRef.current;
    const start:any = textarea.selectionStart;
    const end:any = textarea.selectionEnd;
    const currentText = body;

    const nextVarNumber = dynamicVariables.length + 1;
    const insertText = `{{${nextVarNumber}}}`;

    const updatedText = currentText.slice(0, start) + insertText + currentText.slice(end);

    setBody(updatedText);
    textarea.focus();

    // Manually trigger change logic
    const matchedVars = Array.from(new Set(updatedText.match(/{{\d+}}/g) || []));
    setDynamicVariables(matchedVars);
  };
  

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
  
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', file.type);               // <–– important

    formData.append('messaging_product', 'whatsapp');
  
    try {
      const response = await fetch('https://graph.facebook.com/v17.0/531157636751620/media', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer EAAQoOMDMYXwBO4pWsjFj4zOv1s4zTrZArDEdUPDzD9nOZAAUKt5YCfzWAFUBjb3ykZCZAsBcffjzc1tQRUma1jrpxsbNXCdhAJ9M54cWhY8ZCcexaOOgGqpVk15CgP0RoO1qQyPEkcEWOfsiR8r210u2mZCohmqGRr409ivgVNSpftKHEfvdLLj0LS9bxFZBKpBMwZDZD',
        },
        body: formData,
      });
  
      const data = await response.json();
      console.log('Uploaded Media Response:', data);
  
      if (data.id) {
        setHeaderHandle([data.id]);
        console.log(data.id, 'uploaded ID');
        snack.success('File uploaded successfully');
      } else {
        console.error('Upload failed', data);
        snack.error('Failed to upload file');
      }
    } catch (error) {
      console.error('Error uploading media:', error);
      snack.error('Error uploading file');
    }
  };
  


  return (
    <Box sx={{ margin: 2, padding: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{display:"flex",gap:"30px"}}>
      <TextField
        required
        label="Template Name"
        onChange={handleTemplateChange}
        variant="outlined"
        name="templateName"
        value={templateName}
      />

      <FormControl variant="outlined" style={{ width: '150px' }}>
        <InputLabel id="language-select-label">Language</InputLabel>
        <Select
          labelId="language-select-label"
          id="language-select"
          value={language}
          onChange={handleLanguageChange}
          label="Language"
        >
          {languages.map((lang, index) => (
            <MenuItem key={index} value={lang}>
              {lang}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" style={{ width: '150px' }}>
        <InputLabel id="category-select-label">Category</InputLabel>
        <Select
          labelId="category-select-label"
          id="category-select"
          value={category}
          onChange={handleCategoryChange}
          label="Category"
        >
          {categories.map((cat, index) => (
            <MenuItem key={index} value={cat}>
              {cat}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      </Box>
      <Box sx={{display:"flex",flexDirection:"column",gap:"20px"}}>
      <Typography>Content</Typography>
      <Typography>Fill out the header, body and footer sections of your template.</Typography>
      <FormControl variant="outlined" style={{ width: '150px' }}>
        <InputLabel id="language-select-label">Variable *</InputLabel>
        <Select
          labelId="variableId"
          id="variable-select"
          value={variable}
          onChange={handleVariableChange}
          label="Varaible"
        >
          {variables.map((variable, index) => (
            <MenuItem key={index} value={variable}>
              {variable}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" style={{ width: '150px' }}>
          <InputLabel id="header-label">Header</InputLabel>
          <Select
            labelId="header-label"
            id="header-select"
            value={header}
            onChange={handleHeaderChange}
            label="Header"
          >
            {headers.map((headerOption, index) => (
              <MenuItem key={index} value={headerOption}>
                {headerOption}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* Conditional Section Based on Header Type */}
        {header === 'Text' && (
           <TextField sx={{width:"200px"}}
           required
           label="Header Text"
           onChange={handleHeaderTextChange}
           variant="outlined"
           name="header"
           value={headerText}
         />

        )}

        {(header === 'Image' || header === 'Document') && (
          <Box>
             {/* here upload input  */}
             <input type="file" accept="image/*,.pdf,.doc,.docx" onChange={handleFileUpload} />

          </Box>
        )}

      </Box>
      <Box sx={{ position: 'relative', width: '500px' }}>
        <Typography
          variant="caption"
          sx={{ position: 'absolute', top: 0, right: 0, color: 'gray', padding: '4px' }}
        >
          {body.length}/1024
        </Typography>
        <TextField
          inputRef={bodyRef}
          sx={{ mt: 3 }}
          variant="outlined"
          fullWidth
          name="Body"
          rows={4}
          multiline
          onChange={handleBodyChange}
          size="small"
          label="Body of template"
          value={body}
          inputProps={{ maxLength: 1024 }}
        />

        <Button sx={{ mt: 1 }} onClick={insertVariableAtCursor} variant="outlined">
          Add Variable
        </Button>
      </Box>
      {/* Dynamic Variable Sample Inputs */}
      {dynamicVariables.length > 0 && (
        <Box sx={{display:"flex",flexDirection:"column"}}>
          <Typography variant="subtitle1" sx={{ mt: 2 }}>
          Samples for body content
          </Typography>
          <Typography>To help us review your message template, please add an example for each variable in your body text. Do not use real customer information. Cloud API hosted by Meta reviews templates and variable parameters to protect the security and integrity of our services.</Typography>
          {dynamicVariables.map((variable) => (
            <TextField
              key={variable}
              label={`Sample for ${variable}`}
              // fullWidth
              sx={{ mt: 1,width:"300px" }}
              size="small"
            />
          ))}
        </Box>
      )}
      <Box sx={{mt:2}}>
        <Typography >
          Footer optional
        </Typography>
        <TextField
        required
        label="Footer Text"
        onChange={handleFooterChange}
        variant="outlined"
        name="footerText"
        value={footerText}
        sx={{mt:2}}
      />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
  <Typography variant="h6">Buttons Section</Typography>
  <Typography
          variant="caption"
          sx={{ position: 'absolute', top: 0, right: 0, color: 'gray', padding: '4px' }}
        >
          {quickReplyText.length}/25
        </Typography>  <TextField  size='small'
    label="Quick Reply Text"
    value={quickReplyText}
    onChange={(e) => setQuickReplyText(e.target.value)}
    sx={{width:"300px"}}
  />

 
</Box>

     <Box>
      <Button color="primary" onClick={submitTemplate} >
  Create Template
</Button>
</Box>
    </Box>
  );
};

export default WhatsAppTemplateCreator;
